import React from 'react';

const Info = () => {
    return ( 
        <div className="contenedor">
            <div className="resumen">
                <h6 className="titulo">Autor</h6>
                <span className="resuladospan"></span>
            </div>
            <div className="autor cuerpo">
                <h2>Magister en Ciencias de la computacion Gean Carlo Vitorino Monjaras</h2>
            </div>
            
            <div className="instuciones">
                <p className="cuerpo" >Proyecto apoyado por CONACYT (Consejo Nacional de Ciencia y Tecnología) de Mexico, en conjunto de Universidad Autonama del Estado de Morelos (UAEM), Centro de Investigacion en Ingeniería y Ciencias Aplicadas (CIICAP) y Universidad Autonoma de Yucatana (UADY) </p>
                <img src={require("../../img/instituciones.png")} alt="intituciones"/>
            </div>

            

            <div className="links">
                <p className="titulo ">Links</p>
                <ul className="cuerpo">
                    <li>Tesis Posgrado de Maestria en Ciencias de la Compuatacion, Modelo de delimitación de techos para el uso de paneles fotovoltaicos basado en inteligencia artificial por Gean Carlo Vitorino Monjaras</li>
                    <li>Tesis de Ingeniería, Informe Tecnico SIG de una analisis socioenergetico hacia un panorama renovable</li>
                </ul>
            </div>
        </div>
     );
}
 
export default Info;
